var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfit = function SvgProfit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#8F9194",
    clipPath: "url(#profit_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.48 7.82h-1.69c-.21 0-.41.14-.47.34-.17.49-.44.94-.81 1.33s-.5.91-.34 1.33l.43 1.1c.11.27.31.47.56.56.09.03.19.05.28.05.14 0 .29-.04.41-.11 1.7-1 2.29-2.54 2.49-3.65a.78.78 0 0 0-.2-.67.91.91 0 0 0-.67-.28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.88 4.1c1.29 0 2.43.87 2.78 2.1.09.33.39.55.72.55h.08l2.25-.23c.21-.02.4-.13.53-.3.12-.17.17-.39.13-.6C12.71 2.58 9.99.37 6.88.37 3.21.37.23 3.35.23 7.01a6.65 6.65 0 0 0 6.64 6.64c.34 0 .68-.03 1.01-.08a.748.748 0 0 0 .6-.98l-.72-2.2a.745.745 0 0 0-.75-.52h-.15A2.9 2.9 0 0 1 3.97 7v-.02a2.9 2.9 0 0 1 2.9-2.89zm-.37 7.26.25.78c-2.53-.05-4.61-1.94-4.97-4.39h.76a4.41 4.41 0 0 0 3.96 3.61m-3.97-5.1h-.75c.33-2.23 2.1-4.01 4.34-4.33v.74a4.38 4.38 0 0 0-3.58 3.6z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "profit_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgProfit;